import { get, post } from 'services';
import { AxiosPromise } from 'axios';
import { IgetUserApiData } from 'types/index';

export const getUserReport = (
  getUserApiData: IgetUserApiData
): AxiosPromise<{ data: { rows: any[]; count: number } }> => {
  return get({
    subUrl: '/reporting/suspicious-activity',
    params: getUserApiData
  });
};

export const toggleIsReviewAlert = (data: {
  id: string;
  is_checked: boolean;
}): AxiosPromise<any> => {
  return post({
    subUrl: '/reporting/update-activity-status',
    data: data
  });
};
export const getExportReport = () => {
  return get({
    subUrl: '/reporting/export-suspicious-activity'
  });
};

export const getUserActivityList = (id: any) => {
  return get({
    subUrl: '/reporting/activityList',
    params: { id }
  });
};
